import { Injectable } from "@angular/core";
import { AnnotationConstraints, ConnectorModel, NodeModel, TextModel } from "@syncfusion/ej2-angular-diagrams";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: "root",
})
export class SharedHTMLSettingsDataService {
    public ToasterConfig = {
        closeButton: true,
        timeOut: 4500,
        easing: "ease-out",
        progressBar: true,
        positionClass: "toast-top-right",
        tapToDismiss: true,
        showEasing: "swing",
        hideEasing: "linear",
        showMethod: "fadeIn",
        hideMethod: "slideUp",
    };
    public PhoneNumberMask: String = '(000)000-0000';
    private connectionErrorShown = false;

    constructor(private toastr: ToastrService) {
        window.addEventListener('offline', this.handleOffline);
        window.addEventListener('online', this.handleOnline);
    }

    private handleOffline = (): void => {
        this.showConnectionError();
    };

    private handleOnline = (): void => {
        this.connectionErrorShown = false;
    };

    private showConnectionError(): void {
        if (this.connectionErrorShown) {
            return;
        }

        this.connectionErrorShown = true;
        this.toastr.error('Internet connection lost. Please check your connection.', 'Connection Error', this.ToasterConfig);
    }


    // Call this from API error callbacks.
    public handleApiError(err: any, defaultMessage?: string): void {
        if (err?.status === 0 || !navigator.onLine) {
            this.showConnectionError();
            return;
        }

        if (defaultMessage) {
            this.toastr.error(defaultMessage, 'Error', this.ToasterConfig);
        }
    }

    public isInternetAvailable(): boolean {
        return navigator.onLine;
    }

    public nodeDynamic: NodeModel = {
        shape: {
            type: 'Text',
        } as TextModel,
        offsetX: 250,
        offsetY: 250,
        width: 100,
        height: 30,
        visible: true,
        style: { fill: 'none', textAlign: 'Left' },
        annotations: [{
            content: '',
            constraints: AnnotationConstraints.ReadOnly,

        }]
    };
    public connectorDynamic: ConnectorModel = {
        id: 'd1',
        segments: [
            {
                type: "Straight"
            }],
        sourcePoint: { x: 100, y: 100 },
        targetPoint: { x: 350, y: 100 },
        targetDecorator: { shape: 'None' },
        annotations: [{
            content: '',
            style: {
                textAlign: 'Left',
            },
            alignment: 'Before',
            displacement: { x: 0, y: 20 },
            constraints: AnnotationConstraints.ReadOnly
        }]
    };

    getFontSize() {
        let fontSizeList = [];
        for (let i = 1; i <= 12; i++) {
            fontSizeList.push(i);
        }
        for (let i = 14; i <= 48; i += 2) {
            fontSizeList.push(i);
        }
        return JSON.parse(JSON.stringify(fontSizeList));
    }

    closeModalById(modalId: string) {
        const modalEl = document.getElementById(modalId);
        if (modalEl) {
            const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        document.body.classList.remove('modal-open');
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    }

    openModalById(modalId: string) {
        const modalEl = document.getElementById(modalId);
        if (modalEl) {
            let modal = window['bootstrap'].Modal.getInstance(modalEl);
            if (!modal) {
                modal = new window['bootstrap'].Modal(modalEl, { backdrop: 'static', keyboard: false });
            }
            modal.show();
        }
    }

}
